<template>
  <div class="ViewAbout">

    <h2>Om Ekokammaren</h2>

    <p>
      Ekokammaren låter dig ta del av och jämföra nyheter från olika perspektiv. Syftet är inte att ge en neutral eller allsidig nyhetsbild, utan att synliggöra det faktum att nyheter och information ofta är mer eller mindre vinklad utifrån avsändare och syfte. Medan vissa avsändare strävar efter att ge en neutral bild av en händelse, kan andra källor redogöra om samma händelse med hård vinkling, medvetet felaktig kringfakta, förhastade slutsatser, osv.
    </p>

    <p>
      På Ekokammaren presenteras olika typer av avsändare sida vid sida, exempelvis:
      <ul>
        <li>
          Seriös journalistik
        </li>
        <li>
          Forskare och ämnesexperter
        </li>
        <li>
          Propagandaspridare
        </li>
      </ul>
    </p>

    <p>
      Som besökare kan du fundera över vilka perspektiv du själv tar del av i dina dagliga nyhetsflöden, och vilka perspektiv <i>andra</i> tar del av. Målet är en ökad inblick i, och förståelse för, olika personers världsbild och hur dessa förstärks av våra digitala och analoga nyhetsflöden.
    </p>

    <p>
      Frågor att fundera på och diskutera:
      <ul>
        <li>
          Vilka nyheter tar du del av, och vem är avsändaren?
        </li>
        <li>
          Hur påverkas du av nyheterna?
        </li>
        <li>
          Vilken nyhetsbild får andra ta del av, som du missar?
        </li>
        <li>
          Vilka nyheter tror du på, och vilka tror du inte på?
        </li>
        <li>
          Hur påverkas samhället av att olika personer läser vitt skilda nyheter?
        </li>
      </ul>
    </p>

    <h3>Hur fungerar Ekokammaren?</h3>
    <p>
      Ekokammaren presenterar olika nyhetssidors publika <a href="https://sv.wikipedia.org/wiki/RSS" target="_blank">RSS-flöden</a> sida vid sida, indelade i teman och kolumner utifrån respektive avsändares perspektiv. Avsändare som är placerade i samma kolumner har ingen nödvändig relation till varandra, utan indelningen är kurerad av Ekokammaren utifrån hur respektive avsändare beskriver sig själv, samt vad andra skriver om avsändaren, exempelvis på <a href="https://sv.wikipedia.org/wiki/Lista_%C3%B6ver_svenska_tidningar_ordnade_efter_ideologi" target="_blank">Wikipedia</a>.
    </p>

    <h3>Vem har skapat Ekokammaren?</h3>
    <p>
      Ekokammaren är ett politiskt och religöst oberoende initiativ och verktyg, designat och utvecklat av <a href="https://interaktivarum.se" target="_blank">Interaktiva rum</a>. Interaktiva rum/Ekokammaren lägger ingen värdering i de samlade källornas artiklar och reportage, och då syftet med webbplatsen är att belysa ett polariserat nyhetsklimat utesluts inte avsändare utifrån exempelvis lögner och hårt vinklade nyheter. Ekokammaren är ingen nyhetsredaktion, och publicerar inte egna nyhetstexter.
    </p>

    <h3>Kommentarer och förslag</h3>
    <p>
      Har du kommentarer eller förslag på vidareutveckling eller teman/jämförelser? Tveka inte att ta kontakt.
    </p>


    <h3>Kontakt</h3>
    <a href="mailto:martin@interaktivarum.se">martin@interaktivarum.se</a>

  </div>
</template>

<script>
export default {
  name: 'ViewAbout',
  components: {
  }
}
</script>

<style scoped lang="scss">

  .ViewAbout{
    padding-top: var(--padding-top-view) !important;
  }

</style>
